// extracted by mini-css-extract-plugin
export var orderSummary = "_ks-0";
export var showMoreLessButton = "_ks-1";